import { render } from "./ComicComponent.vue?vue&type=template&id=c57270d6&scoped=true"
import script from "./ComicComponent.vue?vue&type=script&lang=js"
export * from "./ComicComponent.vue?vue&type=script&lang=js"

import "./ComicComponent.vue?vue&type=style&index=0&id=c57270d6&scoped=true&lang=css"

import exportComponent from "/media/shared/vue/comicviewer-with-router/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57270d6"]])

export default __exports__